import React, { useEffect } from "react";
import { StyledPageInput } from "./styled";
import { PageInputProps } from "../../types/PageInputProps";

const PageInput = ({ pageIndex, onChangePageIndex }: PageInputProps) => {
  const [pageValue, setPageValue] = React.useState(pageIndex);
  const debounceTimeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setPageValue(pageIndex);
  }, [pageIndex]);

  useEffect(() => {
    if (!pageValue || pageValue < 1) {
      return;
    }

    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    debounceTimeoutRef.current = setTimeout(() => {
      if (pageValue !== pageIndex) {
        onChangePageIndex(pageValue);
      }
    }, 1000);

    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, [pageValue, pageIndex, onChangePageIndex]);

  return (
    <StyledPageInput>
      <input
        style={{
          border: "none",
          outline: "none",
          width: "100%",
          color: "#000",
          fontFamily: "Inter",
          fontSize: "1rem",
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "normal",
          textAlign: "center",
        }}
        value={pageValue}
        onChange={(e) => {
          const newValue = e.currentTarget.value;
          setPageValue(newValue);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onChangePageIndex(pageValue);
          }
        }}
      />
    </StyledPageInput>
  );
};

export default PageInput;
